/*
  Sportconic loopband-keuzehulp (sections/sportconic-quiz.liquid).

  Eén vraag per scherm, Volgende/Vorige, en aan het eind precies één model met de reden
  waarom. De keuzelogica (decide) is een pure functie zonder DOM, zodat ze in Node met
  alle antwoordcombinaties doorgerekend kan worden (zie de export onderaan).

  Volgorde van beslissen:
  1. Pool: alleen modellen die Liquid heeft gerenderd, dus leverbaar in de markt van de
     bezoeker en niet verborgen voor dat land. Prijzen zijn de live marktprijzen in centen.
  2. Harde filters (veiligheid en functie, gaan altijd voor): maximaal gebruikersgewicht,
     benodigde snelheid (hardlopen = minimaal 10 km/u, dus nooit een walking pad), en voor
     bureaugebruik alleen modellen die onder een bureau passen.
  3. Rangorde: eerst of hij past waar hij moet staan (plat opbergen), dan hoe goed hij bij
     het doel past, dan de laagste prijs. Bij gelijke geschiktheid wint dus de goedkoopste.
  4. Budget is zacht: past niets binnen budget, dan het goedkoopste geschikte model met een
     eerlijke zin over hoeveel het erboven zit en waarom goedkopere niet passen.

  Advies-URL: bij 'Toon mijn advies' laadt de pagina opnieuw met ?result=<model> (bv.
  ?result=t155, of ?result=none zonder passend model). Pixels via Shopify (Meta, Google, TikTok)
  meten alleen echte paginaladingen, dus zo zien ze een paginaweergave met die URL en zijn
  bezoekers van het advies later te targeten. Alleen het model staat in de URL. De antwoorden
  gaan via sessionStorage van dit tabblad mee over het herladen en worden bij het inlezen
  meteen gewist: het gewichtsantwoord komt dus niet in de URL, cookies of analytics.
  Let op bij doelgroepen: pixels leggen de URL vast vóór deze JS draait. Wie een gedeelde
  advies-link opent of het advies herlaadt, telt dus ook mee (en ziet zelf de quiz).
*/
(function (root) {
  'use strict';

  var RUN_MIN_KMH = 10;


  /* Rangsleutel: [past bij opbergen (0/1), doelpunten]. Hoger is beter.
     Doelen (vraag 1): desk = wandelen tijdens het werk (standaard verborgen), active = meer
     stappen, burn = afvallen/calorieën (alleen modellen voor lange trainingen, zie decide;
     daarbinnen weegt helling het zwaarst),
     fitter = conditie opbouwen (kunnen opbouwen: joggen, helling, programma's), run = intensief
     trainen zoals hardlopen. */
  function goalPoints(m, goal) {
    if (goal === 'desk') return m.desk ? 3 : 0;
    if (goal === 'active') return (m.handrail && m.flat) ? 1 : 0; // leuning telt alleen bij wandelmodellen die plat opbergen
    if (goal === 'burn') return (m.incline >= 9 ? 2 : (m.incline > 0 ? 1 : 0)) + (m.handrail ? 1 : 0) + (m.programs > 0 ? 1 : 0);
    if (goal === 'fitter') return (m.max_speed >= RUN_MIN_KMH ? 1 : 0) + (m.incline > 0 ? 1 : 0) + (m.programs > 0 ? 1 : 0) + (m.handrail ? 1 : 0);
    if (goal === 'run') return (m.belt >= 110 ? 1 : 0) + (m.belt >= 120 ? 1 : 0) + (m.motor >= 2.5 ? 1 : 0) + (m.programs > 0 ? 1 : 0);
    return 0;
  }
  /* Hoe vaak loopt iemand nu hard (vraag 2). l0 = niet: handsteunen geven houvast, maar alleen
     bij modellen die plat opbergen (anders wint een grote loopband van een wandelmodel).
     l1 = af en toe: neutraal. l2 = regelmatig (1-2x/week): bij trainingsdoelen tellen modellen
     voor lange trainingen mee. l3 = vaak (3x+/week): bij trainingsdoelen alleen modellen voor lange trainingen
     (harde filter in decide) en daarbinnen het snelste model met het grootste loopvlak.
     Bij 'meer stappen' en 'bureau' telt het niveau niet mee. */
  var TRAIN_GOALS = { burn: 1, fitter: 1, run: 1 };
  function levelPoints(m, ans) {
    if (ans.level === 'l0') return (m.handrail && m.flat) ? 1 : 0;
    if (!TRAIN_GOALS[ans.goal]) return 0;
    if (ans.level === 'l2') return m.endurance ? 1 : 0;
    if (ans.level === 'l3') return (m.max_speed >= 14 ? 1 : 0) + (m.belt >= 120 ? 1 : 0);
    return 0;
  }
  /* Trainingsvoorkeur (vraag 3): een minimale snelheid en extra punten in de rangorde.
     walk = wandelen (geen eis, geen extra punten), jog = joggen (min. 10 km/u), run = hardlopen
     (min. 12 km/u; 14 km/u en een langer loopvlak tellen), interval = intervaltraining
     (min. 10 km/u; modellen voor lange trainingen en met programma's tellen). */
  var PREF_MIN_KMH = { jog: RUN_MIN_KMH, interval: RUN_MIN_KMH, run: 12 };
  function prefPoints(m, pref) {
    if (pref === 'run') return (m.max_speed >= 14 ? 1 : 0) + (m.belt >= 110 ? 1 : 0);
    if (pref === 'interval') return (m.endurance ? 1 : 0) + (m.programs > 0 ? 1 : 0);
    return 0;
  }
  function spaceFit(m, space) { return (space === 'flat' && !m.flat) ? 0 : 1; }
  function cmpKey(a, b, ans) {
    var sa = spaceFit(a, ans.space), sb = spaceFit(b, ans.space);
    if (sa !== sb) return sb - sa;
    var ga = goalPoints(a, ans.goal) + levelPoints(a, ans) + prefPoints(a, ans.pref);
    var gb = goalPoints(b, ans.goal) + levelPoints(b, ans) + prefPoints(b, ans.pref);
    if (ga !== gb) return gb - ga;
    if (a.price !== b.price) return a.price - b.price;
    return a.order - b.order;
  }

  /* Budgetankers: de pool op prijs, zonder de allerduurste; de eerste drie. */
  function anchors(pool) {
    var s = pool.slice().sort(function (a, b) { return a.price - b.price || a.order - b.order; });
    return s.slice(0, Math.max(0, Math.min(3, s.length - 1)));
  }
  function weightBounds(pool) {
    var lo = Infinity, hi = 0;
    pool.forEach(function (m) { lo = Math.min(lo, m.max_kg); hi = Math.max(hi, m.max_kg); });
    return { low: lo, high: hi };
  }

  /* Welke antwoorden zijn zichtbaar voor deze pool (markt). */
  function visibleAnswers(pool) {
    var wb = weightBounds(pool), a = anchors(pool);
    return {
      s14: pool.some(function (m) { return m.max_speed >= 14; }),
      w_high: wb.high > wb.low,
      b1: a.length >= 1, b2: a.length >= 2, b3: a.length >= 3
    };
  }

  function decide(pool, ans) {
    if (!pool.length) return { status: 'nostock' };
    // Waar hij gebruikt wordt (vraag 4): onder het bureau of op een vaste plek hoeft hij niet
    // opgeborgen; de opbergvraag wordt dan overgeslagen en telt niet mee.
    if (ans.location === 'desk' || ans.location === 'fixed') ans = Object.assign({}, ans, { space: 'stays' });
    var wb = weightBounds(pool);
    var needKg = { w_low: wb.low, w_high: wb.high, w_over: wb.high + 1, w_skip: 0 }[ans.weight] || 0;
    if (ans.weight === 'w_over') return { status: 'nomatch', cause: 'weight', kg: wb.high };

    var speedKmh = { s6: 6, s12: 12, s14: 14 }[ans.speed] || 0;
    if (ans.goal === 'desk') speedKmh = 0; // snelheids- en voorkeursvraag worden bij bureau overgeslagen
    var prefKmh = ans.goal === 'desk' ? 0 : (PREF_MIN_KMH[ans.pref] || 0);
    var reqKmh = Math.max(speedKmh, prefKmh, ans.goal === 'run' ? RUN_MIN_KMH : 0);

    var safeKg = pool.filter(function (m) { return m.max_kg >= needKg; });
    var safe = safeKg.filter(function (m) { return m.max_speed >= reqKmh; });
    // Onder het bureau (doel 'bureau' of plek 'onder mijn bureau'): alleen modellen die daar passen.
    // Past er geen bij de rest van de antwoorden (bv. hardlopen), dan een gewone loopband met een
    // notitie waarom. Het verborgen doel 'bureau' houdt de oude harde regel (anders 'geen advies').
    var atDesk = ans.goal === 'desk' || ans.location === 'desk';
    var fit = safe, deskFallback = false;
    if (atDesk) {
      var deskFit = safe.filter(function (m) { return m.desk; });
      if (deskFit.length || ans.goal === 'desk') fit = deskFit;
      else deskFallback = true;
    }
    var deskOnly = atDesk && !deskFallback;
    // Opbergen onder bed, bank of bureau is een harde eis: alleen modellen die plat inklappen.
    // Past er geen enkel plat model bij de rest van de antwoorden, dan toch het beste andere
    // model, met de opbergnotitie.
    if (ans.space === 'flat' && !deskOnly) {
      var flatFit = fit.filter(function (m) { return m.flat; });
      if (flatFit.length) fit = flatFit;
    }
    // Afvallen, en elk trainingsdoel van iemand die al regelmatig hardloopt: alleen modellen die
    // gemaakt zijn voor lange trainingen (blokinstelling 'endurance'), als die er in deze markt
    // zijn. Ze hoeven dan niet plat op te bergen: de opbergnotitie vertelt hoe hij inklapt.
    // Onder het bureau en plat opbergen gaan voor: binnen die modellen zoeken (zijn er daar geen
    // voor lange trainingen, dan geldt de regel niet).
    var experienced = ans.level === 'l3' && !!TRAIN_GOALS[ans.goal];
    var sturdyOnly = false;
    if ((ans.goal === 'burn' || experienced) && !deskOnly) {
      var sturdy = fit.filter(function (m) { return m.endurance; });
      if (sturdy.length) { fit = sturdy; sturdyOnly = true; }
    }

    if (!fit.length) {
      if (ans.goal === 'desk') {
        var deskAny = pool.filter(function (m) { return m.desk; });
        var deskKg = deskAny.reduce(function (x, m) { return Math.max(x, m.max_kg); }, 0);
        return deskAny.length ? { status: 'nomatch', cause: 'desk', kg: deskKg } : { status: 'nostock' };
      }
      if (!safeKg.length) return { status: 'nomatch', cause: 'weight', kg: wb.high };
      return { status: 'nostock' };
    }

    var anc = anchors(pool);
    var capModel = { b1: anc[0], b2: anc[1], b3: anc[2] }[ans.budget] || null;
    var cap = capModel ? capModel.price : Infinity;
    var inBudget = fit.filter(function (m) { return m.price <= cap; });

    var primary, over = null;
    if (inBudget.length) {
      primary = inBudget.slice().sort(function (a, b) { return cmpKey(a, b, ans); })[0];
    } else {
      primary = fit.slice().sort(function (a, b) {
        return a.price - b.price || cmpKey(a, b, ans);
      })[0];
      // Waarom vallen de goedkopere modellen af? Viel er een binnen budget alleen af door de regel
      // 'modellen voor lange trainingen', dan een eigen, neutrale zin (niets negatiefs over dat
      // model). Anders gewicht vóór snelheid.
      var cheaper = pool.filter(function (m) { return m.price <= cap; });
      var cause = 'other';
      var passesHard = function (m) { return m.max_kg >= needKg && m.max_speed >= reqKmh && (ans.goal !== 'desk' || m.desk); };
      if (sturdyOnly && cheaper.some(passesHard)) cause = 'endurance';
      else if (cheaper.some(function (m) { return m.max_kg < needKg; })) cause = 'weight';
      else if (cheaper.some(function (m) { return m.max_speed < reqKmh; })) cause = 'speed';
      over = { anchor: capModel, cause: cause, low: ans.budget === 'b1' };
    }

    var notes = [];
    if (ans.speed === 's6' && (ans.goal === 'run' || prefKmh > 6)) notes.push({ key: 'contradiction' });
    // 14 km/u gekozen zonder hardloopdoel: alleen de tip 'kies 12 km/u' geven als dat echt een
    // voordeliger advies oplevert (bij veel hardlopen of een hoger gewicht blijft het de T155).
    if (ans.speed === 's14' && ans.goal !== 'run' && ans.goal !== 'desk') {
      var alt = decide(pool, Object.assign({}, ans, { speed: 's12' }));
      if (alt.primary && alt.primary.price < primary.price) notes.push({ key: 'fast' });
    }
    if (over) notes.push({ key: over.low ? 'over_low' : 'over', anchor: over.anchor, cause: over.cause });
    if (deskFallback) notes.push({ key: 'desk_nofit', other: pool.filter(function (m) { return m.desk; })[0] || null });
    if (experienced && sturdyOnly) notes.push({ key: 'experienced' });
    if (ans.space === 'flat' && !primary.flat) notes.push({ key: 'storage' });

    // Liever voordeliger? Alleen bij wandelen op wandeltempo, als er een goedkoper model is dat ook past.
    if (!over && ans.goal === 'active' && (ans.speed === 's6' || ans.speed === 'unsure' || !ans.speed)) {
      var cheap = fit.filter(function (m) { return m.price < primary.price && spaceFit(m, ans.space) === spaceFit(primary, ans.space); })
        .sort(function (a, b) { return a.price - b.price; })[0];
      if (cheap) notes.push({ key: 'cheaper', other: cheap });
    }

    // Hardlopen op het kleinste loopvlak: eerlijk melden dat een langer loopvlak prettiger loopt.
    if ((ans.goal === 'run' || ans.pref === 'run') && primary.belt < 110) {
      var better = fit.filter(function (m) { return m.belt >= 110; }).sort(function (a, b) { return a.price - b.price; })[0];
      if (better) notes.push({ key: 'belt', other: better, upright: ans.space === 'flat' && !better.flat });
    }

    // Gewicht overgeslagen: de grens noemen. Staat de gewichtsvraag helemaal uit (weightHidden),
    // dan geen gewichtsnotities (keuze van de winkel; de specificaties staan op de productpagina).
    if (ans.weight === 'w_skip' && !ans.weightHidden) {
      notes.push({ key: 'weight_skip' });
      if (deskOnly) {
        notes.push({ key: 'weight_desk' });
      } else {
        var heavy = safe.filter(function (m) { return m.max_kg > primary.max_kg && m.max_speed >= reqKmh; })
          .sort(function (a, b) { return a.price - b.price; })[0];
        if (heavy) notes.push({ key: 'weight_heavier', other: heavy });
      }
    }

    // Welke redentekst: gewicht 110–120 → 'heavy'; 14 km/u → 'fast'; anders per doel.
    var reason = deskOnly && primary.reasons.desk ? 'desk' : ans.goal;
    if (ans.weight === 'w_high' && primary.reasons.heavy) reason = 'heavy';
    else if (ans.speed === 's14' && ans.goal !== 'desk' && primary.reasons.fast) reason = 'fast';

    return { status: over ? 'over' : 'match', primary: primary, reason: reason, notes: notes };
  }

  var api = { decide: decide, anchors: anchors, weightBounds: weightBounds, visibleAnswers: visibleAnswers, goalPoints: goalPoints, levelPoints: levelPoints, prefPoints: prefPoints };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
  if (typeof document === 'undefined') return;

  /* ─────────────────────────── UI ─────────────────────────── */

  /* Icoontjes voor de trustregel, zelfde als op de productpagina: levering, retour, garantie. */
  var TRUST_ICONS = [
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>'
  ];

  /* Advies-URL (zie boven). STORE_KEY staat ook in het inline script van de sectie. */
  var RESULT_PARAM = 'result';
  var STORE_KEY = 'sp-quiz-answers';
  function takeStored() {
    try {
      var v = sessionStorage.getItem(STORE_KEY);
      sessionStorage.removeItem(STORE_KEY);
      return v ? JSON.parse(v) : null;
    } catch (e) { return null; }
  }
  function putStored(v) {
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify(v));
      return sessionStorage.getItem(STORE_KEY) != null;
    } catch (e) { return false; }
  }
  // Huidige URL met (of zonder) ?result=, overige parameters (utm, view, preview) blijven staan.
  function resultUrl(id) {
    var u = new URL(root.location.href);
    if (id) u.searchParams.set(RESULT_PARAM, id); else u.searchParams.delete(RESULT_PARAM);
    return u.toString();
  }
  function hasResultParam() {
    try { return new URL(root.location.href).searchParams.has(RESULT_PARAM); } catch (e) { return false; }
  }
  function dropResultParam() {
    if (!hasResultParam()) return;
    try { root.history.replaceState(root.history.state, '', resultUrl(null)); } catch (e) {}
  }

  function fill(tpl, vars) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (all, k) { return vars[k] != null ? vars[k] : all; });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function init(sec) {
    if (sec.getAttribute('data-quiz-init')) return;
    sec.setAttribute('data-quiz-init', '1');
    // Opgeslagen antwoorden altijd meteen opnemen en wissen, ook als ze niet gebruikt worden
    // (afgebroken laden, pagina zonder ?result=): niets blijft in het tabblad achter.
    var saved = takeStored();
    var dataEl = sec.querySelector('script[data-quiz-data]');
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { data = null; }
    if (!data) { sec.classList.remove('is-restoring'); return; } // nooit een leeg scherm
    var pool = data.models || [];
    var T = data.text || {};
    var diffs = data.diffs || {};
    var byId = {};
    pool.forEach(function (m) { byId[m.id] = m; });

    var steps = [].slice.call(sec.querySelectorAll('[data-quiz-step]'));
    var resultEl = sec.querySelector('[data-quiz-result]');
    var progressEl = sec.querySelector('[data-quiz-progress]');
    var barEl = sec.querySelector('[data-quiz-bar]');
    var btnNext = sec.querySelector('[data-quiz-next]');
    var btnBack = sec.querySelector('[data-quiz-back]');
    var navEl = sec.querySelector('[data-quiz-nav]');
    var progWrap = sec.querySelector('[data-quiz-progress-wrap]');
    var startEl = sec.querySelector('[data-quiz-start]');
    var cardEl = sec.querySelector('[data-quiz-card]');
    // Kop boven de vragen: bij een advies vervangen door de resultaatkop, terug bij de vragen.
    var headEl = sec.querySelector('.quiz-head .quiz-h1');
    var headOrig = headEl ? headEl.innerHTML : '';
    function setHead(html) {
      if (!headEl) return;
      // Resultaatkop is een instelling (inline richtext, bv. met <em> voor een blauw woord).
      headEl.innerHTML = html || headOrig;
      headEl.classList.toggle('is-result', !!html);
    }
    // Stappen die niet gerenderd zijn (uitgezet) krijgen een vast antwoord: snelheid 'weet niet'
    // (de voorkeur bepaalt dan de minimale snelheid), geen budgetgrens, en het gewicht 'niet
    // opgegeven' zodat het advies de grens als notitie noemt.
    function baseAns() {
      var a = {};
      if (!sec.querySelector('[data-quiz-step="speed"]')) a.speed = 'unsure';
      if (!sec.querySelector('[data-quiz-step="weight"]')) { a.weight = 'w_skip'; a.weightHidden = true; }
      if (!sec.querySelector('[data-quiz-step="budget"]')) a.budget = 'none';
      return a;
    }
    var ans = baseAns();
    var cur = 0;
    // Alle vinkjes weg (opnieuw beginnen, of een advies dat niet terug te zetten is). Ook bij het
    // laden: de browser zet bij vorige/volgende oude vinkjes terug, terwijl ans leeg begint (de
    // radio's hebben daarom ook autocomplete="off").
    function clearAnswers() {
      ans = baseAns();
      [].slice.call(sec.querySelectorAll('input[type=radio]')).forEach(function (r) { r.checked = false; });
    }
    clearAnswers();

    function diff(a, b) { return diffs[a.id + '|' + b.id] || diffs[b.id + '|' + a.id] || ''; }

    // Antwoorden die in deze markt niet kunnen (bv. 14 km/u zonder T155) verbergen.
    var vis = visibleAnswers(pool);
    [['s14', vis.s14], ['w_high', vis.w_high], ['b1', vis.b1], ['b2', vis.b2], ['b3', vis.b3]].forEach(function (p) {
      var inp = sec.querySelector('input[value="' + p[0] + '"]');
      if (inp && !p[1]) inp.closest('[data-quiz-option]').hidden = true;
    });

    function activeSteps() {
      return steps.filter(function (s) {
        var k = s.getAttribute('data-quiz-step');
        if ((k === 'speed' || k === 'pref') && ans.goal === 'desk') return false;
        if (k === 'space' && (ans.location === 'desk' || ans.location === 'fixed')) return false; // hoeft niet opgeborgen
        return true;
      });
    }
    function chosen(step) {
      var inp = step.querySelector('input:checked');
      return inp ? inp.value : null;
    }
    function show(i, focus) {
      var list = activeSteps();
      cur = Math.max(0, Math.min(i, list.length - 1));
      steps.forEach(function (s) { s.hidden = true; });
      resultEl.hidden = true;
      navEl.hidden = false;
      if (progWrap) progWrap.hidden = false;
      setHead(null);
      var step = list[cur];
      step.hidden = false;
      progressEl.textContent = fill(T.progress, { n: cur + 1, total: list.length });
      if (barEl) barEl.style.width = Math.round(((cur + 1) / list.length) * 100) + '%';
      btnBack.hidden = cur === 0 && !startEl; // met startscherm gaat 'Vorige' op vraag 1 terug naar start
      btnNext.textContent = cur === list.length - 1 ? T.finish : T.next;
      btnNext.disabled = !chosen(step);
      if (focus) { var h = step.querySelector('legend'); if (h) h.focus(); }
    }

    sec.addEventListener('change', function (e) {
      var inp = e.target;
      if (!inp || inp.type !== 'radio') return;
      ans[inp.name.replace('quiz-', '')] = inp.value;
      btnNext.disabled = false;
      // Een antwoord kan latere stappen overslaan (bv. 'onder mijn bureau' slaat de opbergvraag
      // over): teller en knoptekst ('Volgende' / 'Toon mijn advies') direct bijwerken.
      var list = activeSteps();
      progressEl.textContent = fill(T.progress, { n: cur + 1, total: list.length });
      if (barEl) barEl.style.width = Math.round(((cur + 1) / list.length) * 100) + '%';
      btnNext.textContent = cur === list.length - 1 ? T.finish : T.next;
    });

    btnNext.addEventListener('click', function () {
      if (loading) return;
      var list = activeSteps();
      if (!chosen(list[cur])) return;
      if (cur < list.length - 1) { show(cur + 1, true); return; }
      var res = decide(pool, ans);
      // Advies als nieuwe paginalading met ?result= (zie boven). In de thema-editor, of zonder
      // sessionStorage (antwoorden kunnen dan niet mee), het advies gewoon op deze pagina tonen.
      var url = null;
      if (!(root.Shopify && root.Shopify.designMode)) { try { url = resultUrl(resultId(res)); } catch (e) {} }
      if (url && putStored({ path: root.location.pathname, ans: ans })) {
        setLoading(true);
        root.location.assign(url);
        // Laden afgebroken (Stop, geen verbinding): na een tijdje weer bruikbaar.
        loadTimer = setTimeout(function () { setLoading(false); }, 10000);
        return;
      }
      renderResult(res);
    });
    // Laadstatus van 'Toon mijn advies': volle kleur met spinner (niet de grijze 'nog niets
    // gekozen'-stand), aria-busy, en een tweede klik doet niets.
    var loading = false;
    var loadTimer = null;
    function setLoading(on) {
      loading = on;
      clearTimeout(loadTimer);
      btnNext.classList.toggle('is-loading', on);
      if (on) btnNext.setAttribute('aria-busy', 'true'); else btnNext.removeAttribute('aria-busy');
    }
    // Terug met de knop van de browser (bfcache): de pagina staat nog op de laatste vraag. Safari
    // wist radio's met autocomplete="off" na het terugzetten (in een latere taak), dus na één
    // tik de vinkjes opnieuw uit ans zetten.
    root.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      setLoading(false);
      if (!resultEl.hidden) return;
      setTimeout(function () {
        steps.forEach(function (s) {
          var v = ans[s.getAttribute('data-quiz-step')];
          [].slice.call(s.querySelectorAll('input[type=radio]')).forEach(function (r) { r.checked = r.value === v; });
        });
        btnNext.disabled = !chosen(activeSteps()[cur]);
      }, 0);
    });
    btnBack.addEventListener('click', function () {
      if (cur === 0 && startEl) { openStart(); return; }
      show(cur - 1, true);
    });

    /* Startscherm: de vragen (met hun kop) verschijnen na de knop. */
    function openStart() {
      cardEl.hidden = true;
      startEl.hidden = false;
      var b = startEl.querySelector('[data-quiz-begin]');
      if (b) b.focus();
    }
    if (startEl) {
      startEl.querySelector('[data-quiz-begin]').addEventListener('click', function () {
        startEl.hidden = true;
        cardEl.hidden = false;
        // Na scrollen naar de knop: terug naar de kop boven de vragen (scroll-margin in CSS).
        try { if (cardEl.getBoundingClientRect().top < 0) cardEl.scrollIntoView({ block: 'start' }); } catch (e) {}
        show(0, true);
      });
    }

    sec.addEventListener('click', function (e) {
      if (e.target.closest('[data-quiz-restart]')) {
        clearAnswers();
        dropResultParam(); // opnieuw beginnen: de URL claimt geen advies meer
        show(0, true);
      } else if (e.target.closest('[data-quiz-edit]')) {
        show(0, true);
      }
    });

    function noteText(n, res) {
      var p = res.primary;
      var causes = { speed: T.cause_speed, weight: T.cause_weight, other: T.cause_other };
      switch (n.key) {
        case 'contradiction': return T.note_contradiction;
        case 'experienced': return T.note_experienced;
        case 'desk_nofit': return n.other ? fill(T.note_desk_nofit, { desk: n.other.name }) : T.note_desk_none;
        case 'fast': return fill(T.note_fast, { model: p.name });
        case 'over': return fill(n.cause === 'endurance' ? T.note_over_endurance : T.note_over, { diff: diff(p, n.anchor), cause: causes[n.cause] });
        case 'over_low': return fill(n.cause === 'endurance' ? T.note_over_low_endurance : T.note_over_low, { diff: diff(p, n.anchor), cause: causes[n.cause] });
        case 'storage': return fill(T.note_storage, { model: p.name, folded: p.folded });
        // Alleen 'geen handsteunen' noemen als dat klopt (het alternatief heeft ze niet, het advies wel).
        case 'cheaper': return fill(!n.other.handrail && p.handrail ? T.note_cheaper : T.note_cheaper_plain, { cheap: n.other.name, diff: diff(p, n.other), speed: n.other.max_speed });
        case 'belt': return fill(T.note_belt, { better: n.other.name, belt: n.other.belt_text, diff: diff(p, n.other) }) + (n.upright ? ' ' + T.note_belt_upright : '');
        case 'weight_skip': return fill(T.note_weight_skip, { kg: p.max_kg });
        case 'weight_heavier': return fill(T.note_weight_heavier, { heavy: n.other.name, kg: n.other.max_kg });
        case 'weight_desk': return fill(T.note_weight_desk, { kg: p.max_kg });
      }
      return '';
    }

    // onLoad: het advies wordt bij het laden van de pagina getekend (?result=). Dan is de foto
    // het grootste element (LCP): meteen en met voorrang laden, en de pagina staat al bovenaan.
    function renderResult(res, onLoad) {
      steps.forEach(function (s) { s.hidden = true; });
      navEl.hidden = true;
      if (progWrap) progWrap.hidden = true; // geen voortgangsbalk bij het advies
      var out = resultEl.querySelector('[data-quiz-result-body]');
      var html = '';
      setHead(res.status === 'match' || res.status === 'over' ? T.result_heading : null);
      if (res.status === 'match' || res.status === 'over') {
        var p = res.primary;
        var tpl = sec.querySelector('template[data-quiz-model="' + p.id + '"]');
        var reasonTxt = p.reasons[res.reason] || p.reasons[ans.goal] || fill(T.reason_fallback, { model: p.name });
        var notes = res.notes.map(function (n) { return noteText(n, res); }).filter(Boolean);
        var trust = String(T.result_trust || '').split(/\s*·\s*/).filter(Boolean);
        html = '<div class="quiz-result-card">'
          + '<div class="quiz-result-media">' + (tpl ? (onLoad ? tpl.innerHTML.replace('loading="lazy"', 'loading="eager" fetchpriority="high"') : tpl.innerHTML) : '') + '</div>'
          + '<div class="quiz-result-body">'
          + '<div class="quiz-eyebrow">' + esc(T.result_eyebrow) + '</div>'
          + '<h2 class="quiz-result-h" tabindex="-1">' + esc(fill(T.result_title, { model: p.name, product: p.title || p.name })) + '</h2>'
          + '<p class="quiz-result-reason">' + esc(reasonTxt) + '</p>'
          + (notes.length ? '<ul class="quiz-result-notes">' + notes.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>' : '')
          + '<div class="quiz-result-buy"><div class="quiz-result-price">'
          + (p.compare_html ? '<s class="quiz-result-compare"><span class="visually-hidden">' + esc(T.compare_label) + ' </span>' + p.compare_html + '</s>' : '')
          + p.price_html + '</div>'
          + (p.klarna_html ? '<div class="quiz-result-klarna">' + p.klarna_html + '</div>' : '')
          + '<a class="quiz-btn quiz-btn--primary" href="' + esc(p.url) + '">' + esc(fill(T.view_model, { model: p.name })) + '</a></div>'
          + (trust.length ? '<ul class="quiz-result-trust">' + trust.map(function (t, i) { return '<li>' + (TRUST_ICONS[i] || '') + esc(t) + '</li>'; }).join('') + '</ul>' : '')
          + '</div></div>';
      } else {
        var msg = res.status === 'nostock' ? T.nostock : (res.cause === 'desk' ? T.nomatch_desk : T.nomatch_weight);
        html = '<div class="quiz-result-card quiz-result-card--nomatch"><div class="quiz-result-body">'
          + '<h2 class="quiz-result-h" tabindex="-1">' + esc(T.nomatch_title) + '</h2>'
          + '<p class="quiz-result-reason">' + esc(fill(msg, { kg: res.kg })) + '</p>'
          + (T.contact_link ? '<a class="quiz-btn quiz-btn--primary" href="' + esc(T.contact_link) + '">' + esc(T.contact_label) + '</a>' : '')
          + '</div></div>';
      }
      out.innerHTML = html;
      resultEl.hidden = false;
      var h = resultEl.querySelector('.quiz-result-h');
      if (h) h.focus(onLoad ? { preventScroll: true } : undefined);
      if (onLoad) return;
      // Terug naar boven als de kop buiten beeld is (scroll-margin in CSS houdt hem onder de header).
      var top = cardEl || resultEl;
      try { if (top.getBoundingClientRect().top < 0) top.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
    }

    function resultId(res) {
      return (res.status === 'match' || res.status === 'over') ? res.primary.id : 'none';
    }

    /* Opgeslagen antwoorden terugzetten: alleen waarden die als keuze op deze pagina staan
       (en niet verborgen zijn voor deze markt). Klopt het plaatje niet, dan false. */
    function restore(saved) {
      if (!saved || saved.path !== root.location.pathname || !saved.ans) return false;
      steps.forEach(function (s) {
        var k = s.getAttribute('data-quiz-step');
        var v = saved.ans[k];
        if (typeof v !== 'string') return;
        [].slice.call(s.querySelectorAll('input[type=radio]')).forEach(function (r) {
          if (r.value !== v) return;
          var opt = r.closest('[data-quiz-option]');
          if (opt && opt.hidden) return;
          r.checked = true;
          ans[k] = v;
        });
      });
      var list = activeSteps();
      if (!list.every(function (s) { return chosen(s); })) { clearAnswers(); return false; }
      cur = list.length - 1;
      return true;
    }

    // Laden met ?result=: het advies tonen als de antwoorden uit dit tabblad klaarstaan. Anders
    // (gedeelde link, herladen) gewoon de quiz en de parameter weghalen.
    // Alles hieronder gebeurt in één taak: er wordt niets tussendoor getekend. De klasse moet er
    // wel af vóór renderResult, want in een onzichtbaar blok kan de kop geen focus krijgen.
    sec.classList.remove('is-restoring');
    if (hasResultParam() && restore(saved)) {
      if (startEl) startEl.hidden = true;
      if (cardEl) cardEl.hidden = false;
      var res = decide(pool, ans);
      renderResult(res, true);
      // Voorraad of prijs kan tussen klikken en laden veranderd zijn: URL gelijk aan het advies.
      if (new URL(root.location.href).searchParams.get(RESULT_PARAM) !== resultId(res)) {
        try { root.history.replaceState(root.history.state, '', resultUrl(resultId(res))); } catch (e) {}
      }
    } else {
      dropResultParam();
      show(0, false);
    }
  }

  function boot() { [].slice.call(document.querySelectorAll('[data-sp-quiz]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})(this);
